import * as _ from "lodash";
import React, { Fragment } from "react";
import { GoogleAuth } from "./Google";
import { FacebookAuth } from "./Facebook";
import { TiktokAuth} from "./Tiktok";
import { IFormElementAuth } from "../interface/IFormElementAuth";
import MicrosoftAuth from "./Microsoft";
import { SnapChatAuth } from "./Snapchat";
import { Button, Tooltip } from "@material-ui/core";

type props = {
  onGoogleResponse: any;
  onFbResponse: any;
  onTTResponse?: any
  onMSResponse:any;
  onSnapChatResponse:any;
  authGroups: IFormElementAuth[];
  bypassLoginpage:any
  optional_login:boolean;

};

export const LoginAuthButton = (props: props): JSX.Element => {
  const { onGoogleResponse, onFbResponse, authGroups,onTTResponse,onMSResponse,onSnapChatResponse, bypassLoginpage, optional_login} = props;
  const AuthGroups: IFormElementAuth[] = authGroups || [];
  const authType = [<span key="span1" />];
  const hasAnyLogin = optional_login ? _.some(AuthGroups, obj => obj?.value) : false;
  for (let iAuthGroup = 0; iAuthGroup < AuthGroups.length; iAuthGroup++) {
      const TypeName = (AuthGroups[iAuthGroup].type || "")
        .toString()
        .trim()
        .toLowerCase();
      const TypeID = AuthGroups[iAuthGroup].type_id;
      const TokenAPI = AuthGroups[iAuthGroup].token_api;
      const Scope = AuthGroups[iAuthGroup].scope;
      const Fields = AuthGroups[iAuthGroup].fields;
      const AppID = AuthGroups[iAuthGroup].app_id;
      const RID = AuthGroups[iAuthGroup].rid;
      const RedirectURL = AuthGroups[iAuthGroup].redirecturl;
      const TenantUrl = AuthGroups[iAuthGroup].tenanturl;

      if (_.isEqual(TypeName, "google")) {
        authType.push(
          <div style={{ display: "flex", justifyContent: "center" }}>
              <GoogleAuth
                onGoogleResponse={(response: any) => onGoogleResponse(response, TypeID)}
                scope={Scope}
                appid={AppID}
                key={iAuthGroup}
                AuthGroup={AuthGroups[iAuthGroup]}
              />
        </div>
        );
      } else if (_.isEqual(TypeName, "facebook")) {
        authType.push(
          <div style={{display:"flex",justifyContent:"center"}}>
          <FacebookAuth
            onFbResponse={(response: any) => {
              onFbResponse(response, TypeID, TokenAPI);}}
            scope={Scope}
            appid={AppID}
            fields={Fields}
            key={iAuthGroup}
            AuthGroup={AuthGroups[iAuthGroup]}
          />
          </div>
        );
      }
      else if (_.isEqual(TypeName, "tiktok")) {
        authType.push(
          <div style={{display:"flex",justifyContent:"center"}}>

         
          <TiktokAuth
            onTTResponse={(response: any) => {onTTResponse(response, TypeID);}}
            appid={AppID}
            rid={RID}
            redirectURL={RedirectURL}
            key={iAuthGroup}
            AuthGroup={AuthGroups[iAuthGroup]}
          />
           </div>
        );
      }
      else if (_.isEqual(TypeName, "microsoft")) {
        authType.push(
          <div style={{display:"flex",justifyContent:"center"}}>
            <MicrosoftAuth
              appid={AppID}
              tenanturl={TenantUrl}
              redirectURL={RedirectURL}
              key={iAuthGroup}
              AuthGroup={AuthGroups[iAuthGroup]}
              scope={Scope}
              onMSResponse={(response: any) => {
                onMSResponse(response, TypeID);
              }
              }
            ></MicrosoftAuth>
          </div>
         );
      }
      else if (_.isEqual(TypeName, "snapchat")) {
        authType.push(
          <div style={{display:"flex",justifyContent:"center"}}>
          <SnapChatAuth
            onSnapchatResponse={(response: any) => {
              onSnapChatResponse(response, TypeID, TokenAPI);}}
            scope={Scope}
            appid={AppID}
            key={iAuthGroup}
            AuthGroup={AuthGroups[iAuthGroup]}
          />
          </div>
        );
      }
  }
  return <Fragment>{authType}
    { hasAnyLogin &&
      <div style={{ float: "right" }}>
        <Tooltip title={"Continue with existing login"} placement={"top"}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => bypassLoginpage(true)}
          disabled={!hasAnyLogin}
        >Continue</Button>
        </Tooltip>
      </div>
    }
</Fragment>;
};
